import { CASE_PROVIDERS_TAG, CHRONOLOGY_TAG, CHRONOLOGY_UNDO_REDO_HISTORY_TAG } from '../constants';
import { api } from '../core';

export type UndoChronologyResponse = null;

interface UndoChronologyProps {
  caseId: string;
}

const undoChronologyApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postUndoChronology: builder.query<UndoChronologyResponse, UndoChronologyProps>({
      query: ({ caseId }: UndoChronologyProps) => ({
        url: `undo/chronology`,
        method: 'POST',
        body: {
          caseId: caseId,
        },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(api.util.invalidateTags([CASE_PROVIDERS_TAG, CHRONOLOGY_TAG, CHRONOLOGY_UNDO_REDO_HISTORY_TAG]));
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postUndoChronology in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostUndoChronologyQuery } = undoChronologyApi;
